// Marks where traits in an avatar originates from: default web builder value, passed in by client, or selected by user
export enum TraitOriginEnum {
  DEFAULT = 'DEFAULT', // default web builder traits
  MIRROR = 'MIRROR', // passed in by client at create flow, generated by Mirror prediction
  USER = 'USER', // user selected when building avatar
  UNKNOWN = 'UNKNOWN',
}
